import React, { useState, useEffect, useMemo } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomDateTimePicker from "../../../../components/common/CustomDateTimePicker/CustomDateTimePicker";
import CustomTextArea from "../../../../components/common/CustomTextArea/CustomTextArea";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import selectOptionData, {
   destinationData,
   originData,
} from "../../../../constansts/LocalData";
import CustomFileUpload from "../../../../components/common/CustomFileUpload/CustomFileUpload";
import { useFormik } from "formik";
import CustomDatePicker from "../../../../components/common/CustomDatePicker/CustomDatePicker";
import CustomModal from "../../../../components/common/Modal";
import { useSelector, useDispatch } from "react-redux";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import {
   singleTripAsync,
   updateTripManagerAsync,
   updateTripReviewStatusAsync,
} from "../../../../redux/features/tripSlice";
import { useParams, useNavigate } from "react-router-dom";
import { ROLES } from "../../../../constansts/Roles";
import toast from "react-hot-toast";
import * as yup from "yup";
import { editfileSchema } from "../../../../helpers/fileValidationRules";
import {
   adhocSingleTripAsync,
   createActualAdhocAsync,
   updateAdhocTripReviewStatusAsync,
} from "../../../../redux/features/adhocTripSlice";
import moment from "moment";

const updateManagerSchema = yup.object().shape({
   destination_reported_date: yup
      .string()
      .required("Destination Reported Date Time is required!"),
   destination_unloading_date: yup
      .string()
      .required("Destination Uploading Date Time is required!"),
   POD_upload: editfileSchema,
   POD_remarks: yup.string().required("POD remarks is required!"),
});

const AdhocTripEdit = () => {
   const trip = useSelector((state) => state.adhocTrip);
   const singleTrip = trip?.singleTrip;

   const [modal, setModal] = useState({
      isOpen: false,
      type: "",
      title: "",
   });
   const [rejectRemarks, setRejectRemarks] = useState("");
   const [modalData, setModalData] = useState({
      date: "",
      fieldValue: "",
      comment: "",
   });
   const [addMoreError, setAddMoreError] = useState(false);

   const userRoleId = useSelector((state) => state?.auth?.user?.data?.user?.role_id);
   let roleName;
   // Finding the rolename from roles
   for (const key in ROLES) {
      if (ROLES[key] === userRoleId) {
         roleName = key;
      }
   }

   const dispatch = useDispatch();
   const params = useParams();

   // Fetch single trip
   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         adhocSingleTripAsync({
            id: params.id,
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   }, []);

   // Manager update fields
   const handleUpdateManager = (formData) => {
      const request = {
         id: params.id,
         destination_reported_date: formData.destination_reported_date,
         destination_unloading_date: formData.destination_unloading_date,
         POD_upload: formData.POD_upload,
         POD_remarks: formData.POD_remarks,
         model_id: 2,
         action_id: 3,
         trip_status: "closed",
         _method: "PATCH",
      };

      const newData = new FormData();
      Object.entries(request).forEach(([key, value]) => {
         newData.append(key, value);
      });

      dispatch(backdropLoadingAction(true));

      dispatch(
         updateTripManagerAsync({
            data: newData,
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("Updated successfully.");
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   const formik = useFormik({
      initialValues: {
         customername: "",
         vehicle_no: "",
         drivername: "",
         driverno: "",
         lane: "",
         origin: "",
         destination: "",
         ewaybillno: "",
         ewaybill_expiry_date: "",
         invoice_no: "",
         invoice_date: "",
         invoice_value: "",
         customer_lrno: "",
         vehicle_reported_date: "",
         vehicle_disptch_date: "",
         actual_diesel_provided: "",
         actual_adblue_provided: "",
         actual_driver_trip_advance: "",
         actual_miscellaneous_expense: "",
         actualMiscExpenceRemarks: "",
         destination_reported_date: "",
         destination_unloading_date: "",
         POD_upload: "",
         POD_remarks: "",
         trip_status: "",
         review_status: "",
      },
      validationSchema: roleName === "manager" ? updateManagerSchema : "",
      onSubmit: (values) => {
         if (roleName === "manager") {
            handleUpdateManager(values);
         }
      },
   });

   const {
      setValues,
      setFieldValue,
      getFieldProps,
      resetForm,
      handleSubmit,
      errors,
      touched,
      values,
   } = formik;

   useEffect(() => {
      if (singleTrip) {
         setValues({
            customername: singleTrip?.customername ?? "",
            vehicle_no: singleTrip?.fleet_master?.vehicle_no ?? "",
            drivername: singleTrip?.driver_master?.name ?? "",
            driverno: singleTrip?.driverno ?? "",
            lane: singleTrip?.adhoc_lane_masters?.lane_name ?? "",
            origin: singleTrip?.adhoc_lane_masters?.origin_location_master?.name ?? "",
            destination:
               singleTrip?.adhoc_lane_masters?.destination_location_master?.name ?? "",
            ewaybillno: singleTrip?.ewaybillno ?? "",
            ewaybill_expiry_date: singleTrip?.ewaybill_expiry_date ?? "",
            invoice_no: singleTrip?.invoice_no ?? "",
            invoice_date: singleTrip?.invoice_date ?? "",
            invoice_value: singleTrip?.invoice_value ?? "",
            customer_lrno: singleTrip?.customer_lrno ?? "",
            vehicle_reported_date: singleTrip?.vehicle_reported_date ?? "",
            vehicle_disptch_date: singleTrip?.vehicle_disptch_date ?? "",
            actual_diesel_provided: singleTrip?.actual_diesel_provided ?? "",
            actual_adblue_provided: singleTrip?.actual_adblue_provided ?? "",
            actual_driver_trip_advance: singleTrip?.actual_driver_trip_advance ?? "",
            actual_miscellaneous_expense: singleTrip?.actual_miscellaneous_expense ?? "",
            actualMiscExpenceRemarks: "",
            destination_reported_date: singleTrip?.destination_reported_date ?? "",
            destination_unloading_date: singleTrip?.destination_unloading_date ?? "",
            POD_upload: singleTrip?.POD_upload ?? "",
            POD_remarks: singleTrip?.POD_remarks ?? "",
            trip_status: singleTrip?.trip_status,
            review_status: singleTrip?.review_status,
         });
      }
   }, [singleTrip]);

   // Handle approve reject
   const handleApproveReject = (status) => {
      const request = {
         id: params.id,
         model_id: 2,
         action_id: 2,
         status,
         flag: "review_status",
         _method: "PATCH",
      };
      dispatch(backdropLoadingAction(true));
      dispatch(
         updateAdhocTripReviewStatusAsync({
            data: request,
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("Updated successfully.");
               dispatch(
                  adhocSingleTripAsync({
                     id: params.id,
                     done: () => {},
                     err: () => {},
                  }),
               );
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   const handleAddMore = () => {
      if (!Object.values(modalData).every((item) => item)) {
         setAddMoreError(true);
         return;
      } else {
         setAddMoreError(false);
      }
      const payload = {
         model_id: "2",
         action_id: "3",
         adhoc_trip_id: singleTrip?.id,
         field_name: modal.type,
         field_value: modalData.fieldValue,
         comment: modalData.comment,
         date: modalData.date,
      };

      dispatch(backdropLoadingAction(true));
      dispatch(
         createActualAdhocAsync({
            data: payload,
            err: () => {
               dispatch(backdropLoadingAction(false));
               //toast.error("Something went wrong !");
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
               dispatch(adhocSingleTripAsync({ id: params.id }));
               toast.success("Successfully add.");
               setModal((prev) => ({ ...prev, isOpen: false }));
               setModalData({
                  date: "",
                  fieldValue: "",
                  comment: "",
               });
            },
         }),
      );
   };

   // Add more values
   const extraDisel = useMemo(() => {
      return singleTrip?.extras?.find(
         (item) => item.field_name === "actual_diesel_provided",
      );
   }, [singleTrip]);

   const extraAdblue = useMemo(() => {
      return singleTrip?.extras?.find(
         (item) => item.field_name === "actual_adblue_provided",
      );
   }, [singleTrip]);

   const extraDriverTrip = useMemo(() => {
      return singleTrip?.extras?.find(
         (item) => item.field_name === "actual_driver_trip_advance",
      );
   }, [singleTrip]);

   const extraMiscellaneous = useMemo(() => {
      return singleTrip?.extras?.find(
         (item) => item.field_name === "actual_miscellaneous_expense",
      );
   }, [singleTrip]);
   return (
      <>
         <CustomModal
            showModal={modal.isOpen}
            title={modal.title}
            handleCloseModal={() => setModal((prev) => ({ ...prev, isOpen: false }))}
            // Dummy toast added need to call api
            onSubmit={() => {
               if (modal.type === "reject") {
                  handleApproveReject("rejected");
               } else {
                  handleAddMore();
               }
            }}
            child={
               modal.type === "reject" ? (
                  <CustomTextArea
                     name="rejectRemarks"
                     value={rejectRemarks}
                     onChange={(e) => setRejectRemarks(e.target.value)}
                  />
               ) : (
                  <div>
                     <CustomDatePicker
                        require={true}
                        label="Date"
                        onChange={(date) =>
                           setModalData({ ...modalData, date: date.target.value })
                        }
                        value={modalData?.date}
                     />
                     <CustomInput
                        require={true}
                        placeholder="E.g 100Rs"
                        label="Amount"
                        onChange={(value) =>
                           setModalData({ ...modalData, fieldValue: value.target.value })
                        }
                        value={modalData?.fieldValue}
                     />
                     <CustomInput
                        require={true}
                        placeholder="Enter the reason"
                        label="Reason"
                        onChange={(value) =>
                           setModalData({ ...modalData, comment: value.target.value })
                        }
                        value={modalData?.comment}
                     />
                     {addMoreError && (
                        <p className="text-danger">All fields are required!</p>
                     )}
                  </div>
               )
            }
         />
         <div>
            <BodyHeader title="Edit Trip Request" />
            <p className="text-danger pl-3 text-lg font-weight-bold">
               {values.trip_status === "closed" && "Trip has been closed"}
            </p>
            <form className="p-3 shadow-lg" onSubmit={formik.handleSubmit}>
               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">General Details</h3>
                  </div>
                  <div className="card-body">
                     <div className="row">
                        <div className="col-lg-4">
                           <label className="text-bold">Customer name</label>
                           <CustomInput
                              disabled={true}
                              optionData={selectOptionData}
                              name="customername"
                              {...getFieldProps("customername")}
                           />
                        </div>
                        <div className="col-lg-4">
                           <label className="text-bold">Vehicle No.</label>
                           <CustomInput
                              disabled={true}
                              optionData={selectOptionData}
                              name="vehicle_no"
                              {...getFieldProps("vehicle_no")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <label className="text-bold">Driver name</label>
                           <CustomInput
                              disabled={true}
                              optionData={selectOptionData}
                              name="drivername"
                              {...getFieldProps("drivername")}
                           />
                        </div>

                        {/* Driver number */}
                        <div className="col-lg-4">
                           <label className="text-bold">Driver No.</label>
                           <CustomInput
                              disabled={true}
                              optionData={selectOptionData}
                              name="driverno"
                              {...getFieldProps("driverno")}
                           />
                        </div>
                     </div>
                  </div>
               </div>

               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">Lane Details</h3>
                  </div>
                  <div className="card-body">
                     <div className="row">
                        {/* lane name */}
                        <div className="col-lg-4">
                           <label className="text-bold">Lane Name</label>
                           <CustomInput
                              disabled={true}
                              optionData={selectOptionData}
                              name="lane"
                              {...getFieldProps("lane")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <label className="text-bold">Origin</label>
                           <CustomInput
                              disabled={true}
                              optionData={selectOptionData}
                              name="origin"
                              {...getFieldProps("origin")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <label className="text-bold">Destination</label>
                           <CustomInput
                              disabled={true}
                              optionData={selectOptionData}
                              name="destination"
                              {...getFieldProps("destination")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={true}
                              label="E waybill No."
                              id="EWayBillNo"
                              placeholder="E waybill No."
                              name="ewaybillno"
                              {...getFieldProps("ewaybillno")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDateTimePicker
                              disabled={true}
                              label="E Waybill Expiry Date & Time"
                              name="ewaybill_expiry_date"
                              id="EWayExpiry"
                              {...getFieldProps("ewaybill_expiry_date")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={true}
                              label="Invoice No."
                              id="invoiceNo"
                              placeholder="Invoice No."
                              name="invoice_no"
                              {...getFieldProps("invoice_no")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDateTimePicker
                              disabled={true}
                              label="Invoice Date"
                              name="invoice_date"
                              id="invoiceDate"
                              {...getFieldProps("invoice_date")}
                           />
                           EditTrip EditTrip
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={true}
                              label="Invoice value"
                              id="invoiceValue"
                              placeholder="Invoice value"
                              value={values.invoice_value}
                              name="invoice_value"
                              {...getFieldProps("invoice_value")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={true}
                              label="Customer / Eisaku LR no."
                              id="customer_eisakuLRNo"
                              placeholder="Customer / Eisaku LR no."
                              name="customer_lrno"
                              {...getFieldProps("customer_lrno")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDateTimePicker
                              disabled={true}
                              label="Vehicle reported date time"
                              name="vehicle_reported_date"
                              id="vehicleReportedDate"
                              {...getFieldProps("vehicle_reported_date")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDateTimePicker
                              disabled={true}
                              label="Vehicle disptch date time"
                              name="vehicle_disptch_date"
                              id="vehicleDispatchDate"
                              {...getFieldProps("vehicle_disptch_date")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <div className="d-flex align-items-end justify-content-between">
                              <div className="flex-grow-1">
                                 <CustomInput
                                    disabled={true}
                                    label="Actual Diesel provided"
                                    id="actualDiselProvided"
                                    inputType="number"
                                    placeholder="E.g 100 Ltr."
                                    name="actual_diesel_provided"
                                    {...getFieldProps("actual_diesel_provided")}
                                 />
                              </div>
                              {roleName === "corporateAdmin" && (
                                 <div>
                                    <button
                                       disabled={
                                          values.trip_status === "closed" || extraDisel
                                       }
                                       className="btn btn-primary ml-3"
                                       style={{
                                          height: "fit-content",
                                          margin: "18px 0 16px",
                                          width: "100px",
                                       }}
                                       onClick={() =>
                                          setModal({
                                             isOpen: true,
                                             type: "actual_diesel_provided",
                                             title: "Actual Diesel provided",
                                          })
                                       }
                                    >
                                       Add more
                                    </button>
                                 </div>
                              )}
                           </div>
                        </div>

                        <div className="col-lg-4">
                           <div className="d-flex align-items-end justify-content-between">
                              <div className="flex-grow-1">
                                 <CustomInput
                                    disabled={true}
                                    label="Actual Adblue provided"
                                    id="actualAdblueProvided"
                                    inputType="number"
                                    placeholder="E.g 100 Ltr."
                                    name="actual_adblue_provided"
                                    {...getFieldProps("actual_adblue_provided")}
                                 />
                              </div>
                              {roleName === "corporateAdmin" && (
                                 <div>
                                    <button
                                       disabled={
                                          values.trip_status === "closed" || extraAdblue
                                       }
                                       className="btn btn-primary ml-3"
                                       style={{
                                          height: "fit-content",
                                          margin: "18px 0 16px",
                                          width: "100px",
                                       }}
                                       onClick={() =>
                                          setModal({
                                             isOpen: true,
                                             type: "actual_adblue_provided",
                                             title: "Actual Adblue provided",
                                          })
                                       }
                                    >
                                       Add more
                                    </button>
                                 </div>
                              )}
                           </div>
                        </div>

                        <div className="col-lg-4">
                           <div className="d-flex align-items-end justify-content-between">
                              <div className="flex-grow-1">
                                 <CustomInput
                                    disabled={true}
                                    label="Actual driver trip advance"
                                    id="actualDriverTripAdvance"
                                    placeholder="E.g 100Rs"
                                    inputType="number"
                                    name="actual_driver_trip_advance"
                                    {...getFieldProps("actual_driver_trip_advance")}
                                 />
                              </div>
                              {roleName === "corporateAdmin" && (
                                 <div>
                                    <button
                                       disabled={
                                          values.trip_status === "closed" ||
                                          extraDriverTrip
                                       }
                                       className="btn btn-primary ml-3"
                                       style={{
                                          height: "fit-content",
                                          margin: "18px 0 16px",
                                          width: "100px",
                                       }}
                                       onClick={() =>
                                          setModal({
                                             isOpen: true,
                                             type: "actual_driver_trip_advance",
                                             title: "Actual driver trip advance",
                                          })
                                       }
                                    >
                                       Add more
                                    </button>
                                 </div>
                              )}
                           </div>
                        </div>

                        <div className="col-lg-4">
                           <div className="d-flex align-items-end justify-content-between">
                              <div className="flex-grow-1">
                                 <CustomInput
                                    disabled={true}
                                    label="Actual miscellaneous expense"
                                    id="actualMiscExpence"
                                    placeholder="E.g 100Rs"
                                    inputType="number"
                                    name="actual_miscellaneous_expense"
                                    {...getFieldProps("actual_miscellaneous_expense")}
                                 />
                              </div>
                              {roleName === "corporateAdmin" && (
                                 <div>
                                    <button
                                       disabled={
                                          values.trip_status === "closed" ||
                                          extraMiscellaneous
                                       }
                                       className="btn btn-primary ml-3"
                                       style={{
                                          height: "fit-content",
                                          margin: "18px 0 16px",
                                          width: "100px",
                                       }}
                                       onClick={() =>
                                          setModal({
                                             isOpen: true,
                                             type: "actual_miscellaneous_expense",
                                             title: "Actual miscellaneous expense",
                                          })
                                       }
                                    >
                                       Add more
                                    </button>
                                 </div>
                              )}
                           </div>
                        </div>

                        {/* Extras */}
                        <div className="col-lg-12 px-3 mb-3">
                           {/* table heading */}
                           <div className="row ">
                              {extraDisel?.field_value && (
                                 <div className="col-lg-3 border p-0">
                                    <div className="p-2 border-bottom font-weight-bold">
                                       Extra Diesel
                                    </div>
                                    <div className="p-2">
                                       <p>{extraDisel?.field_value} Ltr</p>
                                       <p>
                                          <span className="font-weight-bold">date: </span>
                                          {moment(extraDisel?.date).format("LLL")}
                                       </p>
                                    </div>
                                 </div>
                              )}
                              {extraAdblue?.field_value && (
                                 <div className="col-lg-3 border p-0">
                                    <div className="p-2 border-bottom font-weight-bold">
                                       Extra Adblue
                                    </div>
                                    <div className="p-2">
                                       <p>{extraAdblue?.field_value} Ltr</p>

                                       <p>
                                          <span className="font-weight-bold">date: </span>
                                          {moment(extraAdblue?.date).format("LLL")}
                                       </p>
                                    </div>
                                 </div>
                              )}
                              {extraDriverTrip?.field_value && (
                                 <div className="col-lg-3 border p-0">
                                    <div className="p-2 border-bottom font-weight-bold">
                                       Extra Driver Trip
                                    </div>
                                    <div className="p-2">
                                       <p>{extraDriverTrip?.field_value}</p>
                                       <p>
                                          <span className="font-weight-bold">date: </span>
                                          {moment(extraDriverTrip?.date).format("LLL")}
                                       </p>
                                    </div>
                                 </div>
                              )}
                              {extraMiscellaneous?.field_value && (
                                 <div className="col-lg-3 border p-0">
                                    <div className="p-2 border-bottom font-weight-bold">
                                       Extra Miscellaneous Expense
                                    </div>
                                    <div className="p-2">
                                       <p>{extraMiscellaneous?.field_value}</p>
                                       <p>
                                          <span className="font-weight-bold">date: </span>
                                          {moment(extraMiscellaneous?.date).format("LLL")}
                                       </p>
                                    </div>
                                 </div>
                              )}
                           </div>
                        </div>

                        <div className="col-lg-12">
                           <CustomTextArea
                              disabled={true}
                              label="Miscellaneous Expense Remarks"
                              id="actualMiscExpenceRemarks"
                              name="actualMiscExpenceRemarks"
                              placeholder="Remarks"
                              {...getFieldProps("actualMiscExpenceRemarks")}
                              errors={
                                 touched?.actualMiscExpenceRemarks &&
                                 errors?.actualMiscExpenceRemarks
                              }
                              message={errors?.actualMiscExpenceRemarks}
                           />
                        </div>

                        {/* Manager edit fields */}
                        <div className="col-lg-4">
                           <CustomDateTimePicker
                              disabled={
                                 values.trip_status === "closed" || roleName !== "manager"
                              }
                              label="Destination Reported date time"
                              name="destination_reported_date"
                              id="destinationReportedTime"
                              {...getFieldProps("destination_reported_date")}
                              errors={
                                 touched?.destination_reported_date &&
                                 errors?.destination_reported_date
                              }
                              message={errors?.destination_reported_date}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDateTimePicker
                              disabled={
                                 values.trip_status === "closed" || roleName !== "manager"
                              }
                              label="Destination Unloading date time"
                              name="destination_unloading_date"
                              id="destinationUnloadingTime"
                              {...getFieldProps("destination_unloading_date")}
                              errors={
                                 touched?.destination_unloading_date &&
                                 errors?.destination_unloading_date
                              }
                              message={errors?.destination_unloading_date}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomFileUpload
                              disabled={
                                 values.trip_status === "closed" || roleName !== "manager"
                              }
                              label="POD"
                              id="pod"
                              accept=".jpg, .pdf, .jpeg, .png"
                              {...getFieldProps("POD_upload")}
                              onChange={(e) => {
                                 setFieldValue("POD_upload", e.target.files[0]);
                              }}
                              errors={touched?.POD_upload && errors?.POD_upload}
                              message={errors?.POD_upload}
                           />
                        </div>

                        <div className="col-lg-12">
                           <CustomTextArea
                              disabled={
                                 values.trip_status === "closed" || roleName !== "manager"
                              }
                              label="POD(Remarks)"
                              id="podRemarks"
                              name="POD_remarks"
                              placeholder="Remarks"
                              {...getFieldProps("POD_remarks")}
                              errors={touched?.POD_remarks && errors?.POD_remarks}
                              message={errors?.POD_remarks}
                           />
                        </div>
                     </div>
                     {roleName === "manager" &&
                        values.review_status === "approved" &&
                        values.trip_status !== "closed" && (
                           <div className="d-flex justify-content-center">
                              <button
                                 className="btn btn-primary px-4 py-2"
                                 type="submit"
                                 onSubmit={handleSubmit}
                              >
                                 Close Trip
                              </button>
                           </div>
                        )}
                  </div>
               </div>

               {/* APPROVE REJECT */}
               {roleName === "manager" && (
                  <div className="col-12 mt-4 text-center">
                     {values.review_status !== "approved" && (
                        <button
                           className="btn btn-success px-4 py-3"
                           type="button"
                           onClick={() => handleApproveReject("approved")}
                        >
                           <h6 className="mb-0 text-uppercase">Approve</h6>
                        </button>
                     )}

                     {!(
                        values.review_status === "rejected" ||
                        values.review_status === "approved"
                     ) && (
                        <button
                           className="btn btn-danger ml-3 px-4 py-3"
                           type="button"
                           onClick={() => setModal({ isOpen: true, type: "reject" })}
                        >
                           <h6 className="mb-0 text-uppercase">Reject</h6>
                        </button>
                     )}
                  </div>
               )}
            </form>
         </div>
      </>
   );
};

export default AdhocTripEdit;
